module.exports = __webpack_public_path__ + "static/media/pinned.8560d98f.svg";